export enum BettingStructure {
  NO_LIMIT = 'No Limit',
  POT_LIMIT = 'Pot Limit',
  FIXED_LIMIT = 'Fixed Limit',
}
